import React, { useReducer, useEffect } from "react";

import Html from "./html";
import Reducer from "./reducer";
import Context from "./context";
import { initialState } from "./initialState";
import { getLogs } from "./service";

const AllLogs = () => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        getLogs(1, state.search_text, dispatch);
    }, []);

    return(
        <Context.Provider value={{state, dispatch}}>
            <Html/>
        </Context.Provider>
    );
}

export default AllLogs